import script from "./FormLocker.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormLocker.vue?vue&type=script&setup=true&lang=ts"

import "./FormLocker.vue?vue&type=style&index=0&id=39767301&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39767301"]])

export default __exports__